import locateIcon from "./icons/HomeIcon.svg";

interface ILocateUserProps {
  panTo: Function;
}

function LocateUser({ panTo }: ILocateUserProps) {
  return (
    <button
      className="locateUser"
      onClick={() => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            panTo({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              zoom: 12,
            });
          },
          () => null
        );
      }}
    >
      <img src={locateIcon} alt="World - Zoom Out" />
    </button>
  );
}

export default LocateUser;
